<template>
  <div class="d-flex fd-column">
    <h4 class="h4 m-t-0 m-b-2" selenium="public-profile-services">Services Offered</h4>
    <div class="d-flex">
      <vk-icon
          name="information-filled"
          size="18"
          class="p-r-1 flex-0-0"
          unbounded/>
      <span>
        Prices listed are estimates of the labor cost. Material costs may vary by project.
      </span>
    </div>
    <services-pricing :services="orderedServices"/>
    <a
        v-if="services.length > servicesShown"
        class="link text-center "
        @click="showAllServices = !showAllServices">
      See {{ showAllServices ? 'Less' : 'More' }} Services
    </a>
  </div>
</template>

<script>
import ServicesPricing from '@/components/ServicesPricing';

export default {
  name: 'service-section',
  components: {
    ServicesPricing,
  },
  props: {
    services: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      showAllServices: false,
      servicesShown: 16,
    };
  },
  computed: {
    orderedServices () {
      const servicesCopy = this.services.slice();
      servicesCopy.sort((a, b) => a.name.localeCompare(b.name));
      const endIndex = this.showAllServices ? servicesCopy.length : this.servicesShown;
      return servicesCopy.slice(0, endIndex);
    },
  },
};
</script>
